<template>
    <div>
        <form-base v-on="$listeners" v-if="!isCard" :value="valueLocal" :filter="filter" :hide-delete="hideDelete" :readonly="readonly" :hide-offset="hideOffset" :api-method="apiMethod" :fields="fields" :form-title="formTitle" :is-hover="isHover">
            <template v-slot:field="{ item }">
                <div class="d-flex flex-nowrap align-center justify-center">
                    <v-row>
                        <v-col cols="2">
                            <v-select v-model="item.precision"
                                      :items="enumValues" />
                        </v-col>
                        <v-col cols="10">
                            <v-text-field type="number" key="result" v-model="item.result" label="Result" :dense="isHover" />
                        </v-col>
                    </v-row>
                </div>
            </template>
        </form-base>
        <card-base v-on="$listeners" v-if="isCard" :item="value" :filter="filter" :card-color="cardColor" :readonly="readonly" :fields="fields" :title="formTitle" />
    </div>
</template>

<script>
    import enumService from '../services/enumService'
    import precisionEnum from '../enums/precision'

    export default {
        props: [
            'value',
            'filter',
            'hideDelete',
            'readonly',
            'hideOffset',
            'isCard',
            'cardColor',
            'isHover'
        ],

        components: {
            formBase: () => import('../components/FormBase'),
            cardBase: () => import('../components/CardBase')
        },

        data() {
            return {
                sampleTestForm: () => import('../forms/SampleTestForm'),
                fields: [
                    { type: 'autocomplete', text: 'Sample Test', value: 'sampleTestId', rules: [v => !!v || 'Sample Test is required'], isRequired: true, form: () => import('./SampleTestForm'), apiMethod: 'SampleTests', claim: 'SampleTests' },
                    { type: 'custom' },
                    { type: 'datetime', text: 'Tested On', value: 'testedOn', rules: [v => !!v || 'Tested On is required'], isRequired: true }
                ],
                apiMethod: 'TestResults',
                formTitle: 'Test Result',
            }
        },
        computed: {
            enumValues() {
                let result = enumService.enumAsSelectList(precisionEnum)
                result[0].text = "=";
                result[1].text = "<";
                result[2].text = ">";
                return result;
            },
            valueLocal: {
                get() {
                    if (this.isEmpty(this.value)) {
                        return {
                            precision: "Equal"
                        };
                    }
                    return this.value;
                },
                set(value) {
                    this.$emit("input", value);
                },
            },
        },
    };
</script>
